import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Facebook, Mail } from 'lucide-react';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#050505] border-t border-white/5" data-testid="footer">
      <div className="container mx-auto px-6 md:px-12 py-16 md:py-24">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 md:gap-8">
          {/* Brand */}
          <div className="md:col-span-2">
            <span className="block text-[10px] tracking-[0.3em] text-[#D4AF37] uppercase mb-2">
              Cyprus Craft Gin
            </span>
            <h3 className="font-['Playfair_Display'] text-3xl text-[#F2F0E9] mb-4">
              Salt & Stone
            </h3>
            <p className="text-[#F2F0E9]/60 text-sm max-w-sm leading-relaxed">
              Born where sea meets mountain. Thirty botanicals from coasts and peaks unite in harmony.
            </p>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="text-[10px] tracking-[0.2em] text-[#D4AF37] uppercase mb-6">
              Explore
            </h4>
            <div className="flex flex-col gap-3">
              <Link to="/" className="footer-link">Home</Link>
              <Link to="/story" className="footer-link">Our Story</Link>
              <Link to="/shop" className="footer-link">Shop</Link>
              <Link to="/contact" className="footer-link">Contact</Link>
            </div>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-[10px] tracking-[0.2em] text-[#D4AF37] uppercase mb-6">
              Connect
            </h4>
            <div className="flex flex-col gap-3">
              <a 
                href="mailto:office@saltandstonegin.com" 
                className="footer-link flex items-center gap-2"
              >
                <Mail className="w-4 h-4" />
                office@saltandstonegin.com
              </a>
              <div className="flex gap-3 mt-4">
                <a 
                  href="https://instagram.com/saltandstonegin" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="social-icon"
                  data-testid="social-instagram"
                >
                  <Instagram className="w-4 h-4" />
                </a>
                <a 
                  href="https://facebook.com/SaltAndStoneGin" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="social-icon"
                  data-testid="social-facebook"
                >
                  <Facebook className="w-4 h-4" />
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div className="mt-16 pt-8 border-t border-white/5 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-[#F2F0E9]/30 text-xs">
            &copy; {currentYear} Salt & Stone Gin. All rights reserved.
          </p>
          <p className="text-[#F2F0E9]/30 text-xs">
            Please drink responsibly. Must be 18+ to purchase.
          </p>
        </div>

        {/* Emergent badge - mobile/tablet only (fixed badge hidden on these devices) */}
        <div className="mt-8 flex justify-center lg:hidden">
          <a
            href="https://app.emergent.sh/?utm_source=emergent-badge"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 px-3 py-2 bg-white/10 rounded-lg text-[#F2F0E9]/60 text-xs hover:bg-white/15 transition-colors"
          >
            <img
              src="https://avatars.githubusercontent.com/in/1201222?s=120&u=2686cf91179bbafbc7a71bfbc43004cf9ae1acea&v=4"
              alt="Emergent"
              className="w-4 h-4"
            />
            Made with Emergent
          </a>
        </div>
      </div>
    </footer>
  );
};
